import http from '@libs/http';
import {
  GetBrokerChangeQuery,
  Instrument,
  SearchSymbolsQuery,
  MarketDepthsQuery,
  SymbolCandleStickResult,
  SymbolDeductionsQuery,
  InstrumentSectorResult,
  SectorResult,
} from '@libs/api-reference';

import { TSE_API } from './endpoints';
import { Classification } from './composables/useLiveClassificationSymbolsItemsQuery';

type UpdateSymbolBrokerRequestModelType = {
  isins: string[];
  attachment: string | null;
  tag: number;
};

export function getSymbol(id) {
  return http.get<Instrument>(`${TSE_API}/stockwatch/{id}/simple`, {
    urlParams: { id },
    schema: Instrument,
  });
}

export function searchSymbols(query) {
  return http.get<SearchSymbolsQuery>(`${TSE_API}/instruments`, {
    params: { query },
    schema: SearchSymbolsQuery,
  });
}

export function getSymbolDeductions() {
  return http.get<SymbolDeductionsQuery>(`${TSE_API}/deductions`, {
    schema: SymbolDeductionsQuery,
  });
}

export function getBrokerChangeRequests(params: Record<string, unknown>) {
  return http.get<GetBrokerChangeQuery>(`${TSE_API}/supervisors`, {
    params,
    schema: GetBrokerChangeQuery,
  });
}

export function updateSymbolBrokerRequest(
  data: UpdateSymbolBrokerRequestModelType
) {
  return http.post(`${TSE_API}/supervisors`, data);
}

export function deleteBrokerChangeRequest(requestId: number | string) {
  return http.delete(`${TSE_API}/supervisors/{requestId}`, {
    urlParams: { requestId },
  });
}

export function getSymbolCandleStick(params: {
  isin: string;
  interval: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  dateType: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  startDate?: number;
  baseDate?: number;
  records?: number;
  priceType?: 1 | 2;
}) {
  return http.get<SymbolCandleStickResult>(`${TSE_API}/candlesticks`, {
    params,
  });
}

export function getBuyMarketDepth({ isin, exchangeCode }) {
  return http.get<MarketDepthsQuery>(`${TSE_API}/marketdepths/{isin}/buy`, {
    urlParams: { isin },
    params: { exchangeCode },
    schema: MarketDepthsQuery,
  });
}

export function getSellMarketDepth({ isin, exchangeCode }) {
  return http.get<MarketDepthsQuery>(`${TSE_API}/marketdepths/{isin}/sell`, {
    urlParams: { isin },
    params: { exchangeCode },
    schema: MarketDepthsQuery,
  });
}

export function getClassificationSymbols() {
  return http.get<SectorResult>(`${TSE_API}/sectors`, {
    schema: SectorResult,
  });
}

export function getClassificationSymbolsItems({
  sectorCodes = '',
  name = '',
  types = '',
  subSectorCodes = '',
  instrumentGroupIds = '',
}: Classification) {
  return http.get<InstrumentSectorResult>(`${TSE_API}/sectors/instruments`, {
    params: { sectorCodes, name, types, subSectorCodes, instrumentGroupIds },
    schema: InstrumentSectorResult,
  });
}
